import { SurveyItem, surveyStructure } from '@r1-frontend/survey/context/surveys';

import { RetrieveSurveyProperties } from './types';

type RetrieveContextSurveyProperties = Omit<RetrieveSurveyProperties, 'name'> & {
    name: string,
}

/**
 * Получение контекстного опроса
 *
 * @param {Object} options
 * @param {number} options.providerId - идентификатор провайдера
 * @param {string} options.name - название опроса
 * @param {boolean} [options.withAuth=false] - признак авторизации
 * @returns {(import('../surveys').SurveyItem | undefined)} возвращает контекстный опрос (или undefined, если нужный опрос не найден)
 */
export const retrieveContextSurvey = ({ providerId, name, withAuth = false }: RetrieveContextSurveyProperties): SurveyItem | undefined => {
    if (name in surveyStructure.context) {
        const { survey, providers, excludedProviders, withAuth: withAuthSurvey } = surveyStructure.context[name];

        if (
            withAuthSurvey === withAuth &&
            (!providers.length || providers.includes(Number(providerId))) &&
            (!excludedProviders.length || !excludedProviders.includes(Number(providerId)))
        ) {
            return survey;
        }
    }
};
